module.exports = __webpack_public_path__ + "static/media/confirm.74cfbf8a.svg";